import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchNotification, fetchNotifications, updateNotification } from "../../actions/mine_craft/notificationsActions";

export interface NotificationInterface {
  url: string;

  id: number,
  slug: string,

  title: string,
  subtitle: string,
  body: string,

  title_translations: { [key: string]: string | undefined };
  subtitle_translations: { [key: string]: string | undefined };
  body_translations: { [key: string]: string | undefined };
  empty_locales: string[];

  active: boolean,
  created_at: string,
  updated_at: string
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null
};

const adaptor = createEntityAdapter<NotificationInterface>();

const slice = createSlice({
  name: 'notifications',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchNotifications.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.notifications;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchNotification.fulfilled, (state, action) => {
        const notification = Object.values(action.payload.notification)[0];
        state.entities[notification.id] = notification;
      })

      // #update
      .addCase(updateNotification.fulfilled, (state, action) => {
        const notification = Object.values(action.payload.notification)[0];
        state.entities[notification.id] = notification;
      })
      .addCase(updateNotification.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError
} = slice.actions;

export const {
  selectById: selectNotificationById,
  selectIds: selectNotificationIds,
  selectEntities: selectNotificationEntities,
}  = adaptor.getSelectors<RootState>(state => state.mineCraft.notifications);
